import { router } from "expo-router";
import { useTranslation } from "react-i18next";
import { ScrollView, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { Settings } from "@/components/ui/settings";
import { Text } from "@/components/ui/text";
import { ParentUserCard } from "@/features/menu/ParentUserCard";
import { useAuth } from "@/lib/auth";
import { TEST_IDS } from "../../testIdDefinition";

export default function MenuScreen() {
    const { signOut } = useAuth();
    const { t } = useTranslation();

    return (
        <SafeAreaView className="flex-1 bg-background" edges={["top"]}>
            <View className="items-center pb-4">
                <Text variant="label">{t("menu.title")}</Text>
            </View>
            <ScrollView
                className="flex-1"
                contentContainerClassName="gap-6 px-4 pb-6 pt-2"
            >
                <ParentUserCard />
                <Settings>
                    <Settings.Item
                        label={t("menu.settings")}
                        icon="gear"
                        onPress={() => router.push("/settings")}
                        testID={TEST_IDS[TEST_IDS.SETTINGS_LINK]}
                        group
                    />
                    <Settings.Item
                        icon="phone"
                        label={t("menu.contactUs")}
                        onPress={() => router.push("/contact-us")}
                        testID={TEST_IDS[TEST_IDS.CONTACT_US_LINK]}
                        group
                    />
                </Settings>

                <Button
                    variant="outline"
                    className="mt-6"
                    onPress={() => signOut()}
                    testID={TEST_IDS[TEST_IDS.SIGN_OUT_BUTTON]}
                >
                    <View className="flex-row items-baseline gap-2">
                        <Icon name="right-from-bracket" size={14} />
                        <Text>{t("menu.signOut")}</Text>
                    </View>
                </Button>
            </ScrollView>
        </SafeAreaView>
    );
}
